import {
  DefectiveChart,
  DefectiveChartPropsBase,
} from '@euler/app/tv/components/DefectiveChart';
import { getSiteInspectionDefectiveLevelPatched } from '@euler/app/tv/functions/getSiteInspectionDefectiveLevelPatched';
import { getDefectiveLevel } from '@euler/functions/getDefectiveLevel';
import {
  DefectiveSummary,
  makeDefectiveSummary,
  VehicleInspectionFlow,
} from '@euler/model';
import { TaskDetail } from '@euler/model/task-detail';
import { memo, useMemo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const TaskDefectiveChartView = memo(
  ({
    detail,
    flow,
    target = 'site',
    ...props
  }: {
    detail: TaskDetail;
    flow?: VehicleInspectionFlow;
    target?: 'site' | 'item';
    style?: StyleProp<ViewStyle>;
  } & DefectiveChartPropsBase) => {
    const sites = useMemo(
      () =>
        detail.inspection.sites.filter(
          x => x.flowId == null || flow == null || x.flowId === flow.id,
        ),
      [detail.inspection.sites, flow],
    );
    const items = useMemo(() => sites.flatMap(x => x.items), [sites]);
    const total = target === 'site' ? sites.length : items.length;

    const summary = useMemo<DefectiveSummary>(() => {
      const res = makeDefectiveSummary();
      if (target === 'site') {
        for (const site of sites) {
          const defectiveLevel = getSiteInspectionDefectiveLevelPatched(site);
          res[defectiveLevel]++;
        }
      } else {
        for (const item of items) {
          const defectiveLevel = getDefectiveLevel(
            item.abnormalLevel,
            item.severityLevel,
          );
          res[defectiveLevel]++;
        }
      }
      return res;
    }, [items, sites, target]);

    return <DefectiveChart summary={summary} total={total} {...props} />;
  },
);
